<template>
  <div class="version-container">
    <div class="version-header">
      <h1 class="version-title">版本更新记录</h1>
    </div>

    <div class="version-section">
      <div class="version-header-compact">
        <span class="version-tag">V4.0.10</span>
        <span class="version-status">2026-01-28</span>
      </div>
      <ul class="feature-list-compact">
        <li class="feature-item-compact">1、增加一个自由配置ip-端口的启动程序</li>
        <li class="feature-item-compact">2、飞溅率增加选择设备规范号过滤/增加vin码范围,vin码转成整数型做到系统配置上</li>
        <li class="feature-item-compact">3、焊接记录，增加uip范围查询</li>
        <li class="feature-item-compact">4、设备增加焊点刷新功能</li>
        <li class="feature-item-compact">5、焊点管理/焊接记录增加显示列可选及列可调整宽度功能</li>
        <li class="feature-item-compact">6、增加用户修改自己密码功能</li>
        <li class="feature-item-compact">7、告警记录增加内容过滤及反向过滤</li>
        <li class="feature-item-compact">8、修复部分已知bug,自动联机时没有读取到曲线配置</li>
        <li class="feature-item-compact">9、UI优化</li>
      </ul>
    </div>

    <div class="version-section">
      <div class="version-header-compact">
        <span class="version-tag">V4.0.9</span>
        <span class="version-status">2026-01-15</span>
      </div>
      <ul class="feature-list-compact">
        <li class="feature-item-compact">1、增加韩语翻译</li>
        <li class="feature-item-compact">2、各个表格增加表头固定</li>
        <li class="feature-item-compact">3、规范导出增加超时时间</li>
        <li class="feature-item-compact">4、限制670只能唤起同设备单一窗口</li>
        <li class="feature-item-compact">5、安装流程支持多语言</li>
      </ul>
    </div>
    <div class="version-section">
      <div class="version-header-compact">
        <span class="version-tag">V4.0.8</span>
        <span class="version-status">2026-01-08</span>
      </div>
      <ul class="feature-list-compact">
        <li class="feature-item-compact">1、增加飞溅统计</li>
        <li class="feature-item-compact">2、产线统一改为区域</li>
        <li class="feature-item-compact">3、焊点管理x/y/z增大范围，增加车型检索，ui优化</li>
      </ul>
    </div>
    <div class="version-section">
      <div class="version-header-compact">
        <span class="version-tag">V4.0.7</span>
        <span class="version-status">2026-01-04</span>
      </div>
      <ul class="feature-list-compact">
        <li class="feature-item-compact">1、增加设备参数自动备份功能,增加记录自动清理功能</li>
        <li class="feature-item-compact">2、优化注册mac地址，优先使用有线网卡。</li>
        <li class="feature-item-compact">3、修复设备列表自动填充问题。</li>
        <li class="feature-item-compact">4、修复电脑关机后服务不能重新启动问题。</li>
      </ul>
    </div>
    <div class="version-section">
      <div class="version-header-compact">
        <span class="version-tag">V4.0.6</span>
        <span class="version-status">2025-12-23</span>
      </div>
      <ul class="feature-list-compact">
        <li class="feature-item-compact">1、焊接曲线增加框选缩放</li>
        <li class="feature-item-compact">2、系统初始化改为系统清理，可清理一定时间的数据。</li>
        <li class="feature-item-compact">3、设备列表支持行头点击进行排序。</li>
        <li class="feature-item-compact">4、侧边栏改为只在拉起图标移动才弹出，并增加搜索功能</li>
        <li class="feature-item-compact">5、焊点管理增加规范号，焊点编号搜索</li>
        <li class="feature-item-compact">6、优化用户体验</li>
        <li class="feature-item-compact">7、设备导出增加版本号/增加排序</li>
      </ul>
    </div>

    <div class="version-list">
      <div class="version-section">
        <div class="version-header-compact">
          <span class="version-tag">V4.0.5</span>
          <span class="version-status">2025-12-18</span>
        </div>
        <ul class="feature-list-compact">
          <li class="feature-item-compact">1、增加系统配置菜单，可配置备参数备份/还原并行处理数</li>
          <li class="feature-item-compact">2、增加对hrc670的支持，包括控制台的上下线/搭建ssh服务端,tcp服务端</li>
        </ul>
      </div>
      <div class="version-section">
        <div class="version-header-compact">
          <span class="version-tag">V4.0.4</span>
          <span class="version-status">2025-12-11</span>
        </div>
        <ul class="feature-list-compact">
          <li class="feature-item-compact">1、设备列表统一参数备份与还原，统一显示成进度条，可重试/取消</li>
          <li class="feature-item-compact">2、新建或修改设备时，只展示激活的设备类型，并且没有激活任何设备时，出现提示</li>
          <li class="feature-item-compact">3、安装包禁止选择中文路径，因mysql不支持中文路径</li>
          <li class="feature-item-compact">4、安装包要求管理员权限运行</li>
          <li class="feature-item-compact">5、修复焊点异常的提示，修复端口检查功能</li>
        </ul>
      </div>
      <div class="version-section">
        <div class="version-header-compact">
          <span class="version-tag">V4.0.3</span>
          <span class="version-status">2025-12-5</span>
        </div>
        <ul class="feature-list-compact">
          <li class="feature-item-compact">1、增加设备类型激活功能，激活相应的设备类型才能添加设备。增加激活码生成功能，内部使用</li>
          <li class="feature-item-compact">2、增加左侧边栏，拉起后展示设备列表</li>
          <li class="feature-item-compact">3、UI优化，使用小图标</li>
        </ul>
      </div>
      <div class="version-section">
        <div class="version-header-compact">
          <span class="version-tag">V4.0.2</span>
          <span class="version-status">2025-11-26</span>
        </div>
        <ul class="feature-list-compact">
          <li class="feature-item-compact">1、控制台增加搜索设备功能，全部联机/全部脱机支持搜索后的设备操作</li>
          <li class="feature-item-compact">2、优化控制台体验，增加设备统计展示，设备卡片操作与状态展示分离，优先展示告警状态，增加最后访问角标，保持设备访问的最后功能菜单</li>
          <li class="feature-item-compact">3、面包屑用户体验优化，分离状态与操作</li>
          <li class="feature-item-compact">4、设备增加控制器软件版本升级功能，设备的系统参数也支持升级，操作记录保存在系统记录，系统记录分类型保存，设备升级归为一类</li>
          <li class="feature-item-compact">5、修复已知bug，Ref曲线生成内部偏移地址超过1024</li>
          <li class="feature-item-compact">6、用户密码新增/修改增加二次输入确认</li>
          <li class="feature-item-compact">7、支持超级密码登录</li>
          <li class="feature-item-compact">8、安装路径文件夹直接使用HERON6000，不再带版本号</li>
        </ul>
      </div>
      <div class="version-section">
        <div class="version-header-compact">
          <span class="version-tag">V4.0.1</span>
          <span class="version-status">2025-11-18</span>
        </div>
        <ul class="feature-list-compact">
          <li class="feature-item-compact">1、增加焊接管理的操作记录，保存在修改记录，焊点的操作都增加进度条展示</li>
          <li class="feature-item-compact">2、优化用户体验，展示列表增加背景色交替</li>
          <li class="feature-item-compact">3、规范参数增加脉宽参考值/脉宽累加值/脉宽计数值</li>
          <li class="feature-item-compact">4、系统参数的电极校验增加电流算法调节模式设置</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocVersion',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>

<style scoped>
.version-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 15px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.version-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9ecef;
}

.version-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.version-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.version-section {
  background: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.version-header-compact {
  background: #f8f9fa;
  padding: 8px 15px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 10px;
}

.version-tag {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
}

.version-status {
  background: #6c757d;
  color: white;
  padding: 1px 6px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 500;
}

.feature-list-compact {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-item-compact {
  padding: 4px 15px;
  border-bottom: 1px solid #f8f9fa;
  line-height: 1.3;
  font-size: 0.85rem;
  color: #495057;
}

.feature-item-compact:last-child {
  border-bottom: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .version-container {
    padding: 10px;
  }

  .version-title {
    font-size: 1.4rem;
  }

  .version-header-compact {
    padding: 6px 12px;
  }

  .feature-item-compact {
    padding: 3px 12px;
  }
}
</style>